/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { CDN_URLS, OCI_FOLDERS } from '../config';

export interface HomepageHeroImage {
    id: string;
    name: string;
    url: string;
}

export const homepageHeroImages: HomepageHeroImage[] = [
    {
        id: 'elegant-1',
        name: 'Elegant Grey Coat',
        url: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/elegant_1.png`
    },
    {
        id: 'elegant-stairs',
        name: 'Black Elegance Stairs',
        url: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/elegant_schwarz_stairs.png`
    },
    {
        id: 'fruling-10',
        name: 'Spring Elegance',
        url: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Casual/fruling_10.png`
    },
    {
        id: 'city-herbst',
        name: 'City Autumn Blue',
        url: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/city_herbst_blau_elegance.png`
    },
    {
        id: 'christmas-red',
        name: 'Christmas Red',
        url: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/christmas_red_elegance.png`
    },
    {
        id: 'sport-ski',
        name: 'Sport Ski',
        url: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Sport/sport_ski.png`
    },
    {
        id: 'auto-red',
        name: 'Red Auto',
        url: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Autos/Auto_red_1.jpg`
    }
];
